var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIClose = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.61 -143.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.718,158.876h-6.527a2.368,2.368,0,0,1-2.365-2.365v-6.526a2.367,2.367,0,0,1,2.365-2.364h4.263a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-4.263a1.366,1.366,0,0,0-1.365,1.364v6.526a1.367,1.367,0,0,0,1.365,1.365h6.527a1.367,1.367,0,0,0,1.364-1.365v-4.262a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4.262A2.368,2.368,0,0,1-8.718,158.876Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.832,150.6a.5.5,0,0,1-.353-.146.5.5,0,0,1,0-.707l3.956-3.956a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-3.956,3.956A.5.5,0,0,1-8.832,150.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.876,150.6a.5.5,0,0,1-.353-.146L-9.185,146.5a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l3.956,3.956a.5.5,0,0,1,0,.707A.5.5,0,0,1-4.876,150.6Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_close.48ff5ed3.svg";
export { ForwardRef as ReactComponent };